// extracted by mini-css-extract-plugin
module.exports = {"highlight":"highlight__2TGmj"};